import { NotificationsState } from './types';

export function initialState(): NotificationsState {
  return {
    notifications: [],
  };
}
